import { css } from 'styled-components';
import token from 'styled-token';
import { typographyMixin } from '../typographyMixin';
export var ProgressStepperStepLabelTextMixin = function ProgressStepperStepLabelTextMixin(props) {
  return token({
    fontType: 'ProgressStepper.labelFontType'
  }, function (_ref) {
    var fontType = _ref.fontType;
    return css(["display:block;", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)));
  })(props);
};